import { useState, useEffect } from 'react';
import { billingSubSteps } from '../steps/BillingStep';

export const useClientFormSteps = () => {
  const steps = ['Basics', 'Rate Sheet', 'Multipliers & Surcharges', 'Billing & Invoicing', 'Review'];
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState<boolean[]>(
    steps.map(() => false)
  );
  const [activeSubStepId, setActiveSubStepId] = useState<string | null>(null);

  // Set up intersection observers for billing sub-steps
  useEffect(() => {
    if (currentStep !== 3) {
      return;
    }

    const observers: IntersectionObserver[] = [];
    
    billingSubSteps.forEach(step => {
      const element = document.getElementById(step.targetId);
      if (element) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setActiveSubStepId(entry.target.id);
              }
            });
          },
          {
            rootMargin: "-40% 0px -59% 0px",
            threshold: 0,
          }
        );
        observer.observe(element);
        observers.push(observer);
      }
    });

    return () => observers.forEach(observer => observer.disconnect());
  }, [currentStep]);

  return {
    steps,
    currentStep,
    setCurrentStep,
    completedSteps,
    setCompletedSteps,
    activeSubStepId,
    setActiveSubStepId,
  };
};
